import { Id, SingleSelectField } from "@dgs/core";
import { FC, useMemo } from "react";
import { usePreferencesQuery } from "../shared/api/preferences";
import { PreferenceIndexResource } from "../shared/types";

interface PreferenceSelectProps {
	name: string;
	label: string;
	preferenceId?: Id;
	onChange?: () => void;
}

export const PreferenceSelect: FC<PreferenceSelectProps> = ({ name, label, preferenceId, onChange }) => {
	const { data } = usePreferencesQuery();
	const preferences = useMemo<PreferenceIndexResource[]>(() => data || [], [data]);

	return (
		<SingleSelectField
			options={preferenceId ? preferences.filter((p) => p.id !== preferenceId) : preferences}
			getLabel={(option) => option.name}
			getValue={(option) => option.id}
			name={name}
			label={label}
			onChange={onChange}
			clearable={true}
		/>
	);
};
